import { TextareaProps } from "@/types/component"

import "./index.scss"

import React, { useState } from "react"

const Textarea: React.FC<TextareaProps> = ({
  disabled = false,
  error = false,
  errorMessage,
  label,
  variant = "standard",
  ...props
}) => {
  const [focused, setFocused] = useState(false)
  const [hovered, setHovered] = useState(false)

  const hasValue =
    props.value != null && props.value.toString().trim() !== ""

  return (
    <div
      className={`textarea-container ${variant} ${focused ? "focused" : ""} ${hovered ? "hovered" : ""} ${
        error ? "error" : ""
      } ${disabled ? "disabled" : ""} ${hasValue ? "has-value" : ""}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {label && (
        <label className={`textarea-label ${focused ? "focused" : ""} ${error ? "error" : ""}`}>
          {label}
        </label>
      )}
      <textarea
        className="textarea"
        disabled={disabled}
        onBlur={() => setFocused(false)}
        onFocus={() => setFocused(true)}
        {...props}
      />
      {error && errorMessage && <span className="textarea-error">{errorMessage}</span>}
    </div>
  )
}

export default Textarea
